import { SET_LOYLATITY_OUTLET_DETAILS } from '../actions';

const loyaltyoutlets = (state = [], action) => {
  switch (action.type) {
    case SET_LOYLATITY_OUTLET_DETAILS:
      return [...action.value];
    default: return state;
  }
}

export default loyaltyoutlets;